<template>
  <div class="row cart-item">
    <div
        class="item-details item-details-name"
        :class="discount ? 'col-8' : 'col-9'"
    >

    <div class="inline-group input-group " v-show="!cartItem.reedemptionRule">
        <div v-if="removeButton" class="input-group-prepend">
          <button @click="stepdown" class="btn btn-outline-secondary btn-minus" :disabled='isDisabled'>
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <input @change="updateQt($event)" ref="quantity" class="form-control quantity" min="1" name="quantity"
               :value="cartItem.quantity" type="number" readonly>
        <div v-if="removeButton" class="input-group-append">
          <button @click="stepup" class="btn btn-outline-secondary btn-plus">
            <i class="fa fa-plus"></i>
          </button>
        </div>
        <div class="cart-qty-empty" v-if="cartItem.reedemptionRule"></div>
      </div>
      <div
          v-show="cartItem.reedemptionRule"
          class="cart-qty-empty-mobile"
      ></div>
      <span
          class="d-flex"
          :class="[(cartItem.unavailable ? 'text-line-through' : ''), (isSushi && 'montserrat-500') ]"
      >{{ cartItem.name | camelCase }}</span
      >
      <small v-if="cartItem.modifiers || this.removeButton">
        <template
          v-for="(md, index) in flatCartItemModifiers(cartItem.modifiers ? cartItem.modifiers : [])"
        >


          <div :key="index">
            <span :class="isSushi && 'montserrat-500'">     {{ md.Name }}({{ md.quantity }})</span>

            <template v-if="cartItem.modifiers.length > index + 1"
            >,
            </template
            >

          </div>
        </template>


        <div>
          <a
            v-if="!cartItem.unavailable && this.removeButton"
            href="#"
            :style="mobileStyles.LinkColorTxt"
            @click.prevent="removeCartItem(cartItem)"
            >{{ $t("message.remove") }}</a
          >
          <span class="soldout" v-if="cartItem.soldout"
                :class="isSushi && 'montserrat-500'"
          >({{ $t("message.soldOut") }})</span
          >
          <span class="soldout" v-if="cartItem.unavailable"
                :class="isSushi && 'montserrat-500'"
          >({{ $t("message.unavailable") }})</span
          >
        </div>
      </small>
    </div>
    <div
        v-if="!discount"
        class="col-3 item-price"
        :class="[(cartItem.unavailable ? 'text-line-through' : ''), (isSushi && 'montserrat-500') ]"
    >
      <div>{{ price | formatMoney(currencySign) }}</div>
      <div v-if="getPoints" class="item-points text-success" v-show="this.applicableLoyalityRule.length === 1">
        <span v-if="storeSupportsLoyaltyPoints">
          ({{ getPoints | formatNumber }} pts)
        </span>
      </div>
    </div>
    <div
        class="col-4 item-price"
        v-else
        :class="cartItem.unavailable ? 'text-line-through' : ''"
    >
      <del class="fs-75 pr-2">{{ price | formatMoney(currencySign) }}</del>
      <span>{{ discount | formatMoney(currencySign) }}</span>
      <div v-if="getPoints" class="item-points text-success">
        <span v-if="storeSupportsLoyaltyPoints">
          ({{ getPoints | formatNumber }} pts)
        </span>
      </div>
    </div>
    <div v-if="rollInto" class="col-md-12">
      <div v-for="rt in rollInto.selectedRollIntos" :key="rt.ID">
        <a
            class="run-into-meal-btn row"
            @click="editRollInto(rt)"
            :style="mobileStyles.roolIntoButton"
        >
          <div class="col-9 item-details item-details-name roll-into-mobile">
            <span class="d-flex roll-into-mobile-name">{{
                rollInto.Name | camelCase
              }}</span>
            <small
                v-if="rt.selectedModifiers"
                :style="mobileStyles.primaryColor"
            >
              <template v-for="(md, index) in rt.selectedModifiers">
                {{ md.Name }}({{ md.quantity }})
                <template v-if="rt.selectedModifiers.length > index + 1"
                >,
                </template
                >
              </template>
            </small>
          </div>
          <div class="col-3 item-price">
            {{ rt.appliedDiscount | formatMoney(currencySign) }}
          </div>
        </a>
        <div
            v-if="getRollIntoPoints(rt)"
            class="roll-item-point"
            :style="mobileStyles.primaryColor"
        >
          ({{ getRollIntoPoints(rt) | formatNumber }} pts)
        </div>
      </div>
      <div v-if="getNewRollInto" class="h-100">
        <a
            class="run-into-meal-btn row"
            @click="addrollInto()"
            :style="mobileStyles.roolIntoButton"
        >
          <div
              class="col-12 item-details item-details-name roll-into-mobile-empty"
          >
            <span class="d-flex roll-into-mobile-name">{{
                getNewRollInto.Name | camelCase
              }}</span>
          </div>
        </a>
      </div>
    </div>

    <modal
        class="mt-5"
        ref="rollIntoModal"
        v-if="showRollInto"
        full-header
        @close="closeModal"
        hide-footer
    >
      <template slot="body">
        <div
            class="cart-item"
            style="height: calc(100vh - 170px);overflow-y: auto;margin-bottom: 50px;"
        >
          <Modifiers
              :price-trigger="rollInto"
              @canceled="closeModal"
              :product="rollIntoParams.product"
              :modifiers="rollIntoParams.modifiers"
              :product-id="rollIntoParams.productId"
              @updated="selectRollIntoModiefiers"
              :initial-modifiers="initialModifier(selectedIndex)"
              :rollinto-index="selectedIndex"
              :is-submodifier="true"
              :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/shopping-cart/CartItem.js";
import {priceTriggerType} from "../../../api/constants/priceTriggerEnums";
import Modifiers from "../products/Modifiers";
import modal from "../../modal";
import {mapGetters} from "vuex";

export default {
  components: {modal, Modifiers},
  props: {
    cartItem: {
      type: Object,
      default: () => {
      },
    },
    isSushi: {type: Boolean},
    removeButton: {
      type: Boolean,
      default: true,
      required: false,
    }
  },
  data() {
    return {
      qtyNumbers: [],
      showRollInto: false,
      selectedRollIntoModiefiers: [],
    };
  },
  watch: {
    "cartItem.quantity": function () {
      if (this.rollInto) {
        this.fixRollIntoQuantity();
      }
    },
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "mobileStyles",
      "storeMenu",
      "getPriceTriggerOutcomes",
      "canshowRollInto",
      "applicableLoyalityRule",
      "useStampCollection",
    ]),
    isDisabled() {
      return this.cartItem.quantity == 1
    },
    showRollIntoProduct() {
      if (this.rollInto)
        return this.canshowRollInto({
          ...this.menuCopy.Products[this.cartItem.id],
          quantity: this.cartItem.quantity,
          index: this.rollInto.selectedRollIntos.length,
        });
      return null;
    },
    rollInto() {
      var result = this.getPriceTriggerOutcomes.find(
          (oc) =>
              oc.order == this.cartItem.uniqueId &&
              oc.type == priceTriggerType.rollIntoMealPriceTriggers
      );
      if (result && !result.selectedRollIntos) result.selectedRollIntos = [];
      return result;
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      return {
        product: this.menuCopy.Products[
            this.rollInto.rollIntoProduct.ProductID
            ],
        modifiers: this.menuCopy.ModifierGroups,
        productId: this.rollInto.rollIntoProduct.ProductID,
      };
    },
    getNewRollInto() {
      if (
          this.rollInto &&
          this.cartItem.quantity > this.rollInto.selectedRollIntos.length
      ) {
        return this.showRollIntoProduct;
      } else return null;
    },
  },
  created() {
    shared.createdComponent(this);
  },
  methods: {
    ...shared.methods,
    stepup() {
      this.$refs.quantity.stepUp();
      this.updateQt(this.$refs.quantity.value);
    },
    stepdown() {
      this.$refs.quantity.stepDown();
      this.updateQt(this.$refs.quantity.value);
    }
  },
};
</script>
